import { useEffect, useState } from "react";
import renderModal from "./RenderModal";
import { getLayoutDirection, isMobileApp } from "../../utils/util";

const MedicalReportRequestDashboard = ({ setRequestStep, translationMap, medicalReportAppointmentData, userDetails }) => {
  const [isLoading] = useState(false);

  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, []);

  if (isLoading) return <div>Loading...</div>;
  if (userDetails && userDetails.patientDeathIndicator === "Y") {
    return renderModal(
      "medicalreport01",
      translationMap?.medicalReport,
      "info",
      translationMap?.notAbleToProceed,
      translationMap?.notEligibleMessage,
      <>{translationMap?.haveQuestions} <a href="tel:80060">{translationMap?.callUsOn}{" "}<u>800
                60</u></a></>,
      () => setRequestStep(-1),
      translationMap?.close
    );
  } else if (medicalReportAppointmentData.length === 0) {
    return renderModal(
      "medicalreport02",
      translationMap?.medicalReport,
      "info",
      translationMap?.noAppointment,
      translationMap?.noAppointmentMessage,
      <>{translationMap?.haveQuestions} <a href="tel:80060">{translationMap?.callUsOn}{" "} <u>800
                60</u></a></>,
      () => setRequestStep(-1),
      translationMap?.close
    );
  } else {
    return (
      <>
                <div className={`${getLayoutDirection()} custombody_color`}>
                    <section class="w-100 clearfix MedicalReportMainSection" id="CoverPlanActive">
                        <div class="container customContainer">
                            {!isMobileApp() &&
              <div class="Title_Inner_Box">
                                    <h6 class="MainTitleOne">
                                        {translationMap?.requestAMedicalReport}
                                    </h6>
                                </div>
              }
                            <div class="Step_ul_main_box">
                                <ul class="Step_Info_ul_box">
                                    <li>
                                        <div class="Step_inner_box active_box">
                                            <div class="inner_counter_wrap">
                                                  <span class="count_box">
                                                    1
                                                  </span>
                                                <p>
                                                    {translationMap?.introduction}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="Step_inner_box">
                                            <div class="inner_counter_wrap">
                                                  <span class="count_box">
                                                    2
                                                  </span>
                                                <p>
                                                    {translationMap?.request}
                                                </p>
                                            </div>

                                        </div>
                                    </li>
                                    {userDetails?.age < 60 &&
                  <li>
                                            <div class="Step_inner_box ">
                                                <div class="inner_counter_wrap">
                                                  <span class="count_box">
                                                    3
                                                  </span>
                                                    <p>
                                                        {translationMap?.payment}
                                                    </p>
                                                </div>

                                            </div>
                                        </li>
                  }
                                </ul>
                            </div>
                            <div class="cover_inner_wrapper cover_inner_wrapper2">
                                <div class="cover_main_box1">
                                    <div class="medical_main_inner_wrapper2">
                                        <div class="info_box_wrap1">
                                            <h6 class="Gray_Title">
                                                {translationMap?.medicalReportInfo}
                                            </h6>
                                        </div>
                                        <div class="info_box_wrap2">
                                            {/*<h6 class="Gray_Title">*/}
                                            {/*    {translationMap?.about}*/}
                                            {/*</h6>*/}
                                            <ul class="inner_ul_box">
                                                <li>
                                                    <p>
                                                        {translationMap?.medicalReportText1}

                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        {translationMap?.medicalReportText2}
                                                    </p>

                                                </li>
                                                <li>
                                                    <p>

                                                        {translationMap?.medicalReportText3}

                                                    </p>
                                                </li>
                                                <li>
                                                    <p>

                                                        {translationMap?.medicalReportText4}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        {translationMap?.medicalReportText5}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        {translationMap?.medicalReportText6}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        {translationMap?.medicalReportText7}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        {translationMap?.medicalReportText8}
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="info_box_wrap2">
                                            <h6 class="Gray_Title">
                                                {translationMap?.serviceTime}
                                            </h6>
                                            <ul class="inner_ul_box">
                                                <li>
                                                    <p>
                                                        {translationMap?.tenDay}
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="Sub_Button_Box">
                                            <span>
                                                <button class="blue_btn_link" onClick={() => setRequestStep(1)}>
                                                    {translationMap?.continue}
                                                </button>
                                            </span>
                                            <span>
                                                  <button onClick={() => setRequestStep(-1)}
                        class="Orangetrans_btn_link mrCancelBtn">
                                                    {translationMap?.cancel}
                                                  </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="cover_main_box2">
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>);

  }
};

export default MedicalReportRequestDashboard;